import axios from "axios";

export const axiosAuthInstance = axios.create({withCredentials:true})

